export interface NavItemConfig {
  to: string;
  end?: boolean;
  exact?: boolean;
  exclude?: string;
}

/** Recruiter/affiliate share control belongs with Add candidate + My candidates. */
export function navHasCandidatePages(items: { to: string }[]): boolean {
  const paths = new Set(items.map((item) => item.to));
  return paths.has("/candidates") && paths.has("/candidates/new");
}

export function isNavActive(pathname: string, item: NavItemConfig): boolean {
  if (item.exclude && pathname === item.exclude) return false;
  if (item.end || item.exact) return pathname === item.to;
  return pathname === item.to || pathname.startsWith(`${item.to}/`);
}
